// import { TKIconClose } from 'assets/images/svgs'
import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import ProgressBar from "../components/ProgressBar";
import InputField from "shared/InputField";
import CheckBox from "shared/CheckBox";
import { useFormik } from "formik";
import { useState } from "react";
import { createProjectValidationSchema } from "validation/ngo/project/createProjectSchema";
import { categories } from "utilities/data";
import { useLocation } from "react-router-dom";

const CreateProject = ({ next, setBody }) => {
  const { state } = useLocation();
  const [selectedItems, setSelectedItems] = useState(
    state ? state.project_category : []
  );
  const [donatedItems, setDonatedItems] = useState(
    state
      ? state.items_donation
      : [
          {
            item: "",
            quantity: "",
          },
        ]
  );

  const formik = useFormik({
    initialValues: {
      name: state ? state.name : "",
      location: state ? state.location : "",
      summary: state ? state.summary : "",
      project_category: selectedItems,
      projected_impact: state ? state.projected_impact : "",
      fundraising_goal: state ? state.fundraising_goal : "",
      impact_of_monetary_goal: state ? state.impact_of_monetary_goal : "",
      impact_of_donated_item: state ? state.impact_of_donated_item : "",
      items_donation: donatedItems,
      project_picture: state ? state.project_picture : "",
      impact_video: state ? state.impact_video : "",
      name_of_account: state ? state.name_of_account : "",
      beneficiary_bank: state ? state.beneficiary_bank : "",
      account_number: state ? state.account_number : "",
      signatories: state ? state.signatories : "",
    },
    validationSchema: createProjectValidationSchema,
    onSubmit: (values) => {
      const body = {
        name: values.name,
        location: values.location,
        summary: values.summary,
        project_category: selectedItems,
        projected_impact: values.projected_impact,
        fundraising_goal: values.fundraising_goal,
        impact_of_monetary_goal: values.impact_of_monetary_goal,
        impact_of_donated_item: values.impact_of_donated_item,
        items_donation: donatedItems,
      };
      setBody(body);
      next();
    },
  });

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newItems = [...donatedItems];
    newItems[index] = { ...newItems[index], [name]: value };

    if (name === "quantity") {
      const quantity = parseFloat(newItems[index].quantity);
      if (quantity < 0) {
        return;
      }
    }
    setDonatedItems(newItems);
  };

  const handleAddItem = () => {
    setDonatedItems([...donatedItems, { item: "", quantity: "" }]);
  };

  return (
    <NGODashboardLayout section={state ? "Edit Project" : "Create New Project"}>
      <div className="flex flex-col px-6 max-[450px]:px-0 gap-4">
        <ProgressBar progress="w-[33%]" />
        <div>
          <div className="flex flex-col">
            <div className="flex justify-between items-center">
              <p className="text-[#222] font-semibold text-[28px]">
                {state ? "Edit Project" : "Create Project"}
              </p>
              {
                // <TKIconClose />
              }
            </div>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              Please provide information about the projects you will like
              fundraise for on the Truekeepers website.
            </p>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              <span className="font-bold">Note:</span> You can list information
              for a maximum of 3 projects
            </p>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <p className="text-[#213874] text-[14px] whitespace-nowrap">
                Project Description
              </p>
              <div className="h-[1px] w-full bg-[#CCC]"></div>
            </div>
            <InputField
              name="name"
              label="Project Name/Title"
              numberLabel="1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.name}
              </p>
            ) : null}
            <InputField
              name="location"
              label="Project Location"
              numberLabel="2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.location}
            />
            {formik.touched.location && formik.errors.location ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.location}
              </p>
            ) : null}
            <InputField
              name="summary"
              label="Project Summary"
              subLabel="Short compelling statement of how project will make an impact on beneficiaries. Impact of project till date"
              numberLabel="3"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.summary}
            />
            {formik.touched.summary && formik.errors.summary ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.summary}
              </p>
            ) : null}
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                4
              </div>
              <div className="w-full flex flex-col gap-2">
                <label className="text-[18px]">Project Category</label>
                <label className="text-[14px] text-[#7A7A7A]">
                  Indicate below what category/s this project falls into.
                </label>
                <div className="flex flex-wrap gap-4">
                  {categories.map((checkbox, index) => (
                    <div
                      key={index}
                      className="border border-[#DFDFDF] rounded-md p-2"
                    >
                      <CheckBox
                        defaultChecked={state?.project_category.find((cate) =>
                          checkbox.title.includes(cate)
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems([
                              ...selectedItems,
                              e.target.value,
                            ]);
                          } else {
                            setSelectedItems(
                              selectedItems.filter(
                                (item) => item !== e.target.value
                              )
                            );
                          }
                        }}
                        name={checkbox.title}
                      />
                    </div>
                  ))}
                </div>
                {formik.touched.project_category &&
                formik.errors.project_category ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.project_category}
                  </p>
                ) : null}
              </div>
            </div>
            <InputField
              name="projected_impact"
              label="Projected Project Impact"
              subLabel="How many people will this project impact yearly?"
              numberLabel="5"
              placeholder="2000"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.projected_impact}
            />
            {formik.touched.projected_impact &&
            formik.errors.projected_impact ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.projected_impact}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-4 mt-3">
            <div className="flex items-center gap-3">
              <p className="text-[#213874] text-[14px] whitespace-nowrap">
                Project Needs - Monetary
              </p>
              <div className="h-[1px] w-full bg-[#CCC]"></div>
            </div>
            <InputField
              name="fundraising_goal"
              label="Fundraising Goal"
              subLabel="Please indicate your fundraising goal for this project in Naira"
              numberLabel="6"
              placeholder="1000000"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.fundraising_goal}
            />
            {formik.touched.fundraising_goal &&
            formik.errors.fundraising_goal ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.fundraising_goal}
              </p>
            ) : null}
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                7
              </div>
              <div className="w-full flex flex-col gap-2">
                <label className="text-[18px]">
                  Impact breakdown of monetary goal
                </label>
                <label className="text-[14px] text-[#7A7A7A]">
                  e.g ₦50,000 will feed 50 children every month.
                </label>
                <textarea
                  className="px-4 py-2 bg-white border border-[#E6E6E6] rounded-md placeholder:text-[14px]"
                  rows="5"
                  name="impact_of_monetary_goal"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.impact_of_monetary_goal}
                />
                {formik.touched.impact_of_monetary_goal &&
                formik.errors.impact_of_monetary_goal ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.impact_of_monetary_goal}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-3">
            <div className="flex items-center gap-3">
              <p className="text-[#213874] text-[14px] whitespace-nowrap">
                Project Needs - Items/Goods
              </p>
              <div className="h-[1px] w-full bg-[#CCC]"></div>
            </div>
            <InputField
              name="impact_of_donated_item"
              label="Impact of donated items"
              subLabel="Short description of why items are needed and how they will impact project beneficiaries"
              numberLabel="8"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.impact_of_donated_item}
            />
            {formik.touched.impact_of_donated_item &&
            formik.errors.impact_of_donated_item ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.impact_of_donated_item}
              </p>
            ) : null}
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                9
              </div>
              <div className="w-full flex flex-col gap-2 overflow-x-auto">
                <label className="text-[18px]">List of Items</label>
                <label className="text-[14px] text-[#7A7A7A]">
                  Kindly list items needed for this project. Indicate the
                  quantity needed for each item.
                </label>
                <div className="flex justify-between px-7 items-center bg-[#FAFAFA] h-[40px] border-y border-[#CCCCCC]">
                  <p className="p-2 w-full flex justify-center">Item</p>
                  <p className="p-2 w-full flex border-l justify-center">
                    Quantity
                  </p>
                </div>
                {donatedItems.map((item, index) => (
                  <div key={index} className="flex justify-between">
                    <div className="flex flex-col w-full">
                      <input
                        type="text"
                        id={`name-${index}`}
                        name="item"
                        placeholder="Item"
                        value={item.item}
                        onChange={(event) => handleInputChange(index, event)}
                        className="border-x border-b border-[#CCCCCC] px-2 py-1 h-[60px] focus:outline-none"
                      />
                      {formik.touched.item && formik.errors.item ? (
                        <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                          {formik.errors.item}
                        </p>
                      ) : null}
                    </div>
                    <div className="flex flex-col w-full">
                      <input
                        type="number"
                        id={`quantity-${index}`}
                        name="quantity"
                        placeholder="Qty"
                        value={item.quantity}
                        onChange={(event) => handleInputChange(index, event)}
                        className="border-r border-b border-[#CCCCCC] px-2 py-1 h-[60px] focus:outline-none"
                      />
                      {formik.touched.quantity && formik.errors.quantity ? (
                        <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                          {formik.errors.quantity}
                        </p>
                      ) : null}
                    </div>
                  </div>
                ))}
                <div>
                  <button
                    type="button"
                    onClick={handleAddItem}
                    className="!bg-[#CCCCCC] whitespace-nowrap flex justify-center items-center w-[120px] rounded-[5px] h-[41px] p-3 text-xs md:text-sm font-medium shadow-1px border !border-[#ded7d7] hover:bg-[#CCCCCC]"
                  >
                    Add New Line
                  </button>
                </div>
                {formik.touched.items_donation &&
                formik.errors.items_donation ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.items_donation}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button type="button">
              <p className="p-3 bg-[#CCC] rounded-md">Cancel</p>
            </button>
            <button type="submit">
              <p className="p-3 bg-[#213874] text-white rounded-md">Next</p>
            </button>
          </div>
        </form>
      </div>
    </NGODashboardLayout>
  );
};

export default CreateProject;
